export default "__VITE_ASSET__1jtffNst__"